import axios from 'axios'
import config from './config'
import identityHandler from '@/core/identity-handler'

export function getSchema(section, tenant) {
  //console.log('getSchema', section)
  return getHeaders().then(headers => {
    return axios({
      method: 'get',
      url: config.baseUrl() + '/Document/Schema/' + section.key,
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}
export function getSchemaValues(section, tenant) {
  //console.log('getSchemaValues', section)
  return getHeaders().then(headers => {
    return axios({
      method: 'get',
      url: config.baseUrl() + '/Document/Values/' + section.key,
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

export function getAllSettings(tenant) {
  return getHeaders().then(headers => {
    return axios({
      method: 'get',
      url: config.baseUrl() + '/Document/GetAllSettingsArchive',
      responseType: 'blob',
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

export function uploadSettings(archiveFile, tenant) {
  const formData = new FormData()
  formData.append('settingsArchive', archiveFile, archiveFile.name)

  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/Document/UploadSettings',
      data: formData,
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

export function uploadUnrulyPax(archiveFile, tenant) {
  const formData = new FormData()
  formData.append('unrulyPaxList', archiveFile, archiveFile.name)
  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/Document/UploadUnrulyList',
      data: formData,
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

export function getUnrulyPax(request) {
  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/Document/GetUnrulyPaxLists',
      headers: headers,
      data: formatRequest(request)
    })
  })
}

export function updateValues(section, tenant, values, version) {
  console.log('updateValues rq', values)
  var requestData = {
    values: values,
    version: version
  }

  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/Document/Values/' + section.key,
      params: {
        tenant: tenant
      },
      data: formatRequest(requestData),
      headers: headers
    })
  })
}

export function getSections(tenant) {
  console.log('getSections', tenant)
  return getHeaders().then(headers => {
    return axios({
      method: 'get',
      url: config.baseUrl() + '/User/Sections',
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

export function getUserTenants() {
  console.log('getUserTenants')
  return getHeaders().then(headers => {
    return axios({
      method: 'get',
      url: config.baseUrl() + '/User/Tenants',
      headers: headers
    })
  })
}

export function getHistoryRecords(requestData, section, tenant) {
  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/History/GetHistoryRecords/' + section.key,
      params: {
        tenant: tenant
      },
      data: formatRequest(requestData),
      headers: headers
    })
  })
}

export function getAuditLogs(section, tenant, pageNumber, howMany) {
  const requestData = {
    pageNumber,
    howMany
  }
  return getHeaders().then(headers => {
    return axios({
      method: 'post',
      url: config.baseUrl() + '/History/GetAuditLogs/' + section.key,
      data: formatRequest(requestData),
      params: {
        tenant: tenant
      },
      headers: headers
    })
  })
}

function formatRequest(request) {
  return JSON.parse(JSON.stringify(request))
}

function getHeaders() {
  return identityHandler.getAccessToken().then(accessToken => {
    let authHeader = {
      Authorization: 'Bearer ' + accessToken
    }
    let configHeaders = config.axiosConfig.headers
    let headers = formatRequest(Object.assign(authHeader, configHeaders))
    return headers
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js